import type { CityConfig } from "@/pages/city-template/types";

export const redHookConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Red Hook",
  state: "New York",
  stateAbbr: "NY",
  slug: "red-hook",
  route: "/red-hook",
  title: "Emergency Passport Red Hook, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Red Hook, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Red Hook, Bard College, Tivoli, Hudson Valley farmland, ALB/SWF/JFK travelers, and all northern Dutchess County communities.",
  h1: "Emergency & Expedited Passport Services in Red Hook, NY",
  heroSubtitle: "Bard College professor presenting at a Berlin symposium in 2 weeks? Red Hook farmer heading to Tuscany for an organic agriculture exchange? Hudson Valley family booking a last-minute trip to visit relatives abroad? We help Red Hook residents — from Bard faculty to Tivoli artists to Dutchess County farm families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20rural%20Red%20Hook%20New%20York%20farmland%20in%20northern%20Dutchess%20County%20with%20rolling%20agricultural%20fields%2C%20historic%20red%20barns%20and%20farmhouses%2C%20Bard%20College%20campus%20visible%20in%20the%20distance%20at%20Annandale-on-Hudson%20along%20the%20Hudson%20River%2C%20Berkshire%20Mountains%20on%20the%20horizon%2C%20late%20summer%20golden%20sunlight%20illuminating%20wheat%20fields%20and%20corn%20stalks%2C%20Hudson%20Valley%20pastoral%20landscape%2C%20modern%20editorial%20travel%20photography%20with%20warm%20earth%20tones%2C%20no%20text%20overlay%2C%20clean%20professional%20composition%20capturing%20rural%20American%20beauty&width=1600&height=700&seq=red-hook-hero-v3-001&orientation=landscape",
  heroImageAlt: "Red Hook New York rural farmland with Bard College and Hudson River Valley at golden hour",
  geoPosition: "42.0209;-73.8754",
  geoPlacename: "Red Hook, New York",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~95 miles south in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Red Hook", zips: "12571" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Tivoli", zips: "12583" },
    { name: "Barrytown", zips: "12507" },
    { name: "Annandale-on-Hudson", zips: "12504" },
    { name: "Germantown", zips: "12526" },
    { name: "Livingston", zips: "12541" },
    { name: "Milan", zips: "12571" },
    { name: "Pine Plains", zips: "12567" },
    { name: "Ancram", zips: "12502" },
    { name: "Copake", zips: "12516" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Kingston", zips: "12401, 12402, 12411, 12429, 12432, 12441, 12449, 12484, 12485, 12487, 12490, 12491, 12492, 12496" },
    { name: "Poughkeepsie", zips: "12601, 12602, 12603, 12604" },
    { name: "Hudson", zips: "12534" },
    { name: "Catskill", zips: "12414" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing for Northern Dutchess", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Red Hook-area travelers with immediate departures from ALB, SWF, or JFK." },
    { icon: "ri-graduation-cap-line", title: "Bard College Academic Travel Expertise", desc: "Bard's globally renowned faculty — composers, writers, scientists, artists — travel internationally for residencies, conferences, and collaborations on famously short notice." },
    { icon: "ri-plant-line", title: "Farm-to-Table & Agricultural Exchange", desc: "Red Hook's working farms send producers to European organic agriculture conferences, Tuscan agriturismo exchanges, and French biodynamic farming workshops — seasonal urgency peaks at planting and harvest." },
    { icon: "ri-landscape-line", title: "Rural Dutchess County Lifestyle", desc: "From the Tivoli Bays to the Roeliff Jansen Kill, from Poet's Walk Park to Bard's Fisher Center — Red Hook blends rural tranquility with world-class cultural connections." },
  ],
  internalLinks: [
    { name: "Fast passport services in Rhinebeck, NY", route: "/rhinebeck" },
    { name: "Expedited passport in Hudson, NY", route: "/hudson-ny" },
    { name: "Quick passport services in Kingston, NY", route: "/kingston" },
    { name: "Urgent passport services in Poughkeepsie, NY", route: "/poughkeepsie" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Red Hook and all of northern Dutchess County via secure registered courier with direct access to the New York Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Red Hook residents can ship from any UPS Store, FedEx Office, or post office location across the Hudson Valley.",
  fpcOfficeDistance: "Serving Red Hook, Tivoli, Rhinebeck, Annandale-on-Hudson, and all rural Dutchess County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Red Hook and northern Dutchess County. From the Bard College campus in Annandale-on-Hudson to the working farms along Route 9G, from the village of Tivoli to the hamlets of Barrytown and Milan — we serve all of rural northern Dutchess. Our courier service eliminates the need to drive 95 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Red Hook and all northern Dutchess County communities including Tivoli, Rhinebeck, Annandale-on-Hudson, Barrytown, Germantown, Milan, and Pine Plains. We also serve Bard College faculty and students, Hudson Valley farmers, and Tivoli artists who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Red Hook as simple as possible — with the efficiency Bard College faculty, Dutchess County farm families, and rural Hudson Valley travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Red Hook travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Red Hook travelers encounter unique passport issues — everything from Bard faculty conference travel with 1–2 week notice to farm-season international exchanges. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Red Hook travelers — from Bard College faculty to Tivoli farmers to Annandale-on-Hudson families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Red Hook, NY? Here are the most common ones we hear from rural Dutchess County travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you're a Bard professor heading to a Berlin conference, a Red Hook farmer traveling to Tuscany for an organic agriculture exchange, or a rural Dutchess family booking a first trip abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Bard College faculty symposium in Berlin — departure in 4 days? Family emergency abroad requiring immediate travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Red Hook-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Red Hook residents renew fast — no agency visit required for most renewals. Perfect for Bard College faculty, Dutchess County farm families, and rural Hudson Valley professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Red Hook residents — from Bard students to Tivoli families — through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your conference travel or farm exchange program is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your rural Dutchess County family vacation or first international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports. Common for Red Hook residents and Bard College faculty after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Bard College faculty with overlapping residencies and Hudson Valley farmers traveling internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Farm work and outdoor activities in rural Dutchess County — dirt, moisture, and equipment damage happen. We guide Red Hook travelers through damaged passport replacement faster than you think.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Red Hook travelers heading to Montreal via the Northway.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Red Hook NY", description: "Urgent passport processing for Red Hook NY travelers, Bard College faculty, and rural Dutchess County residents with immediate departure needs." },
    { name: "Expedited Passport Renewal Red Hook NY", description: "Fast passport renewal for Red Hook NY residents with a previously-issued passport." },
    { name: "First-Time Passport Red Hook NY", description: "New passport application services for Red Hook NY residents and Bard College students applying for their first passport." },
    { name: "Child Passport Red Hook NY", description: "Minor passport services for Red Hook NY families with children under 16." },
    { name: "Name Change Passport Red Hook NY", description: "Passport name correction after marriage, divorce, or legal name changes for Red Hook residents." },
    { name: "Second Passport Red Hook NY", description: "Second passport services for Red Hook Bard faculty and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Professor James H.",
      location: "Bard College, Annandale-on-Hudson",
      rating: 5,
      text: "Received an invitation to present at a composition symposium in Berlin with 10 days notice. My passport had expired during summer research. Fast Passport Center renewed it in 48 hours and I made the opening keynote. The Bard faculty grapevine now recommends them to everyone.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah W.",
      location: "Red Hook, NY",
      rating: 5,
      text: "Running our organic farm means I cannot drop everything. Fast Passport Center handled my passport renewal entirely remotely for an agricultural exchange in Tuscany. The 5-day service was perfect — documentation arrived while I was in the middle of planting season.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas B.",
      location: "Tivoli, NY",
      rating: 5,
      text: "Needed an emergency passport for my daughter's study abroad at Bard College Berlin. The agent guided us through the DS-11 form and acceptance clerk visit in Red Hook. Passport arrived in 5 days — just in time for her semester orientation in Germany.",
      service: "New Passport",
    },
    {
      name: "Laura M.",
      location: "Barrytown, NY",
      rating: 5,
      text: "Lost my passport during a move from Annandale to Barrytown — discovered it was missing 6 days before a family reunion in Ireland. Fast Passport Center handled the replacement in 4 days. The dedicated agent kept me updated daily. Could not be more grateful.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "red-hook-1",
      name: "Red Hook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7460 South Broadway",
      city: "Red Hook",
      state: "NY",
      zip: "12571",
      phone: "(845) 758-8941",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Downtown Red Hook",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Red Hook passport acceptance facility. Small facility with limited appointment slots — book 2+ weeks ahead during peak seasons. Serves Red Hook, Tivoli, and Barrytown residents.",
      icon: "ri-mail-line",
    },
    {
      id: "red-hook-2",
      name: "Rhinebeck Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6387 Mill Street",
      city: "Rhinebeck",
      state: "NY",
      zip: "12572",
      phone: "(845) 876-4031",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rhinebeck — south of Red Hook",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for southern Red Hook and Rhinebeck residents. Larger facility with more appointment slots than Red Hook. Good alternative when Red Hook post office is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "red-hook-3",
      name: "Tivoli Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "73 Broadway",
      city: "Tivoli",
      state: "NY",
      zip: "12583",
      phone: "(845) 757-2301",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Tivoli — north of Red Hook",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Tivoli, Barrytown, and northern Red Hook communities. Small facility — call in advance for appointment availability. Convenient for Bard College students living off-campus in Tivoli.",
      icon: "ri-mail-line",
    },
    {
      id: "red-hook-4",
      name: "Hyde Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "424 Albany Post Road",
      city: "Hyde Park",
      state: "NY",
      zip: "12538",
      phone: "(845) 229-8074",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Hyde Park — south of Red Hook",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Hyde Park, Staatsburg, and southern Red Hook residents. Larger facility than Red Hook — good backup option during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "red-hook-5",
      name: "Columbia County Clerk — Hudson",
      type: "County Clerk Passport Acceptance",
      address: "560 Warren Street",
      city: "Hudson",
      state: "NY",
      zip: "12534",
      phone: "(518) 828-3339",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Hudson — north of Red Hook",
      website: "https://www.columbiacountyny.com/countyclerk.html",
      websiteLabel: "Columbia County Clerk",
      notes: "Columbia County clerk passport acceptance. Convenient for northern Red Hook, Germantown, and Ancram residents. No passport photos on-site.",
      icon: "ri-government-line",
    },
    {
      id: "red-hook-6",
      name: "Bard College — International Students & Scholar Services",
      type: "Campus Passport Resource",
      address: "30 Campus Road, Bertelsmann Campus Center",
      city: "Annandale-on-Hudson",
      state: "NY",
      zip: "12504",
      phone: "(845) 758-7397",
      hours: "Academic year: Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Bard College Campus — Annandale-on-Hudson",
      website: "https://www.bard.edu/isss/",
      websiteLabel: "Bard ISSS",
      notes: "Bard's International Students and Scholar Services provides passport and visa guidance for students, faculty, and researchers. Excellent first stop for Bard community members before contacting Fast Passport Center for expedited processing.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 95 miles to Manhattan Passport Agency", fpc: "Most Red Hook travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays — critical for first-time Bard applicants" },
    { feature: "Bard Faculty Conference Travel", agency: "No accommodation for academic conference timelines", fpc: "We understand the 1–3 week notice typical of Bard faculty conference invitations" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Rural Dutchess-Specific Guidance", agency: "Generic — no Bard, farm community, or northern Dutchess expertise", fpc: "Full Bard College/agricultural/rural Dutchess/ALB-SWF-JFK knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Bard Faculty Waiting Until Conference Acceptance to Check Passport",
      description: "Bard College faculty often receive conference invitations, book flights, and then discover an expired passport with 7–10 days before departure. International conference acceptances should trigger an immediate passport validity check.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Farm-Season Passport Neglect During Planting and Harvest",
      description: "Red Hook farmers are intensely seasonal — passports expire unnoticed during spring planting and fall harvest. By the time winter travel is booked, there is no time for standard processing. Check passport validity during the off-season.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Red Hook Post Office Has Walk-In Availability",
      description: "The Red Hook Post Office is a small facility serving a wide rural area. During Bard College semester transitions (August and January), appointment slots fill 2–3 weeks in advance. Book early or use the Rhinebeck or Hyde Park alternatives.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards for Academic and Professional Use",
      description: "Bard faculty traveling to international conferences need passport photos that meet strict State Department standards. Rural drugstore photos often fail — especially lighting and background issues. We verify every photo before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Multi-Country Itineraries Without Full Validity Check",
      description: "Bard faculty often plan multi-country European trips — conference in Berlin, research in Paris, residency in Rome. Each Schengen entry requires passport validity beyond the return date. We review the full itinerary before submission.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a Bard conference, agricultural exchange, or family trip. Complete your secure order in minutes from your farmhouse or campus office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist with instructions for the nearest acceptance facility — Red Hook Post Office, Rhinebeck, or wherever is most convenient." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Red Hook clients ship from the local post office or UPS drop-off in Rhinebeck — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 95 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives within your chosen timeframe. Whether you are presenting at a conference in Berlin or harvesting grapes in Tuscany — your passport is ready." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Red Hook?", a: "We offer Red Hook-area clients — including Bard College faculty and Dutchess County farm families — expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors." },
    { q: "I am Bard College faculty — can you handle short-notice conference travel?", a: "Absolutely. Bard faculty conference travel with 7–14 days notice is one of our most common scenarios. We understand academic conference timelines and the compressed window between invitation and departure. Our 2–9 day processing is designed for exactly these situations." },
    { q: "Where can I get passport acceptance near Red Hook?", a: "The Red Hook Post Office (7460 South Broadway) is the primary facility. Nearby alternatives include Rhinebeck Post Office (6387 Mill Street), Tivoli Post Office (73 Broadway), and Hyde Park Post Office (424 Albany Post Road). The Columbia County Clerk in Hudson is also an option for northern Red Hook residents." },
    { q: "Does Bard College help with faculty passport processing?", a: "Bard's International Students and Scholar Services provides guidance for students, faculty, and researchers, but does not handle expedited passport processing. Our service bridges the gap — we expedite passports for Bard community members who have fixed conference and residency dates." },
    { q: "What about passport photos — where can I get them near Red Hook?", a: "CVS and Rite Aid in Red Hook and Rhinebeck offer passport photos. Walgreens in Poughkeepsie and Hudson are also convenient. All photos must be 2x2 inches, white background, no glasses. We verify photo compliance before submission." },
    { q: "Can you help farmers and agricultural professionals with passports?", a: "Yes — we regularly assist Red Hook farmers and agricultural professionals with passports for international exchanges, organic farming conferences, and agriturismo programs in Europe. We understand the seasonal constraints of farm life and can coordinate processing around planting and harvest schedules." },
    { q: "I need a visa for my conference in Asia — how does the timeline work?", a: "Bard faculty traveling to China, India, or other visa-requiring countries need both a passport AND a visa. Once you receive your expedited passport, you apply for the visa separately. Plan for 2–4 additional weeks for visa processing. We flag the total timeline before you start." },
    { q: "How much does an expedited passport cost in Red Hook?", a: "Government fees are $130 + $60 expedite fee. Our courier service fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% less than FedEx, Staples, and other third-party resellers." },
    { q: "Does Fast Passport Center have a Red Hook office?", a: "We operate as a remote courier service — no physical office in Red Hook, but our overnight shipping network serves rural Dutchess County efficiently. You can complete everything from your farmhouse, the Bard campus, or any local shipping location." },
    { q: "What airports do Red Hook travelers use?", a: "ALB (Albany International, ~70 miles) is the closest for many Red Hook residents. SWF (Stewart International, ~55 miles) is also convenient. JFK (~95 miles) is the primary global gateway. We coordinate passport timelines around your departure airport." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Red Hook Residents",
    intro: "Red Hook's identity — a rural farming community anchored by one of America's most distinctive liberal arts colleges — creates passport timing challenges that span academic urgency and agricultural seasonality. Here's what Red Hook travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "Bard College — The Liberal Arts Global Engine",
        subtitle: "World-renowned faculty traveling internationally for conferences, residencies, and collaborations",
        description: "Bard College in Annandale-on-Hudson is one of America's most globally connected liberal arts colleges. Its faculty — composers, writers, visual artists, scientists, and humanists — travel internationally year-round for conferences, artist residencies, research collaborations, and performances. Bard's unique academic culture means faculty often receive conference and residency invitations with only 2–3 weeks notice — a timeline that standard passport processing cannot handle.",
        tip: "Bard faculty should maintain passports with at least 12 months of validity at all times. Conference invitations, residency acceptances, and performance bookings often arrive with insufficient time for even expedited passport renewal.",
      },
      {
        icon: "ri-plant-line",
        title: "Red Hook's Agricultural Economy — Farm-to-Table Goes Global",
        subtitle: "Working farms, organic agriculture, and international food system exchange",
        description: "Red Hook is a genuine farming community — not agritourism, but working family farms producing vegetables, fruit, dairy, and livestock. The farm-to-table movement connects Red Hook producers to global food networks: organic agriculture conferences in Europe, biodynamic farming workshops in France, agriturismo exchanges in Tuscany, and seed-saving collaborations worldwide. Farmers operate on seasonal calendars — planting (March–May) and harvest (August–October) leave almost no time for passport errands.",
        tip: "Farm families planning international agricultural exchanges should renew passports during the winter off-season (November–February). Summer and fall are too busy — and acceptance facility appointments fill fast during Hudson Valley tourism season.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB & SWF — Dual-Airport Rural Access",
        subtitle: "Albany International (~70 miles) and Stewart International (~55 miles)",
        description: "Red Hook's rural location means both Albany International and Stewart International are within an hour's drive — but neither is close enough for a last-minute passport fix. ALB offers connections to East Coast hubs. SWF offers the Dublin direct route. The dual-airport choice means Red Hook travelers must have their passport ready before choosing a departure point — driving to one airport, discovering a passport issue, then trying the other is not practical in rural Dutchess County.",
        tip: "Confirm your passport validity before driving to either ALB or SWF. The distance between the two airports is 50+ miles — discovering an expired passport at one airport means you will not make a flight at the other.",
      },
      {
        icon: "ri-palette-line",
        title: "Tivoli Artists & Hudson Valley Creative Community",
        subtitle: "Artists, writers, and musicians in the northern Hudson Valley",
        description: "The village of Tivoli and the surrounding hamlets of Barrytown and Annandale-on-Hudson are home to a thriving community of artists, writers, and musicians — many affiliated with Bard College, others drawn to the Hudson Valley's creative energy. International artist residencies, book tours, concert performances, and gallery exhibitions create consistent passport demand. Like Bard faculty, Tivoli artists often receive short-notice opportunities — a gallery show in Berlin, a residency in Rome, a performance at a European festival.",
        tip: "Artists and performers with international opportunities should maintain valid passports year-round. Grant-funded residencies and festival invitations have fixed start dates — a passport delay can mean losing the opportunity entirely.",
      },
    ],
    callout: {
      icon: "ri-book-open-line",
      title: "The Bard Paradox — World-Class Global Reach, Rural Passport Infrastructure",
      description: "Bard College attracts internationally renowned faculty who travel globally — but operates from a campus in rural Annandale-on-Hudson with limited passport services. The nearest acceptance facility (Red Hook Post Office) has just a handful of appointment slots per week. During semester transitions, the combination of Bard students, faculty, and seasonal residents can overwhelm local facilities for weeks.",
    },
  },
  destinations: {
    title: "Where Red Hook Travelers Go — And Why Passports Get Urgent",
    intro: "Red Hook's academic and agricultural character creates a unique international travel profile. Here's what drives passport urgency from the farmland of northern Dutchess County.",
    stats: [
      { stat: "38%", label: "of Red Hook expedited requests are Bard College faculty academic/conference-related" },
      { stat: "1–3 Weeks", label: "average notice Bard faculty receive from conference invitation to departure" },
      { stat: "Aug–Sep & Jan–Feb", label: "dual peak seasons — fall semester conferences and spring semester residencies" },
      { stat: "48 Hours", label: "shortest turnaround for a Bard professor heading to a Berlin composition symposium" },
    ],
    destinations: [
      { name: "Germany", context: "Bard College Berlin campus, composition and music conferences, academic collaborations, artist residencies", urgency: "Conference invitations with 1–2 week notice — the tightest timeline in the Hudson Valley", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Bard faculty at the American Academy in Rome, Tuscan agriturismo farm exchanges, art history research", urgency: "Residency acceptances announced 4–6 weeks before start — fixed dates", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Bard Paris programs, biodynamic farming workshops in Burgundy, culinary and wine research", urgency: "Summer workshop season — June through August bookings lock in April", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "Bard Oxford and Cambridge collaborations, SWF Dublin direct route, academic publishing and research", urgency: "SWF Dublin route — travelers book Aer Lingus sales 4–6 weeks before travel", icon: "ri-map-pin-2-line" },
      { name: "Scandinavia", context: "Bard Nordic studies and environmental research, sustainable agriculture conferences, design collaborations", urgency: "Nordic academic conferences concentrated in May–June and August–September", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal and Toronto for Bard academic collaborations, Quebec farm-to-table exchanges, weekend art trips", urgency: "Cross-border academic symposia and farm visits booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Rhinebeck", route: "/rhinebeck" },
      { name: "Hudson", route: "/hudson-ny" },
      { name: "Kingston", route: "/kingston" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Red Hook", address: "7488 South Broadway, Red Hook, NY 12571", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Rite Aid — Red Hook", address: "7488 South Broadway, Red Hook, NY 12571", hours: "Daily 8 AM – 9 PM", website: "https://www.riteaid.com/" },
    { name: "Walgreens — Rhinebeck", address: "6700 Route 9, Rhinebeck, NY 12572", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Hyde Park", address: "4250 Albany Post Road, Hyde Park, NY 12538", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Hudson", address: "160 Fairview Avenue, Hudson, NY 12534", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "The UPS Store — Poughkeepsie Plaza", address: "2600 South Road, Poughkeepsie, NY 12601", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart Photo Center — Kingston", address: "601 Frank Sottile Boulevard, Kingston, NY 12401", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "FedEx Office — Kingston", address: "1200 Ulster Avenue, Kingston, NY 12401", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Poughkeepsie",
      address: "13 Corporate Park Drive, Poughkeepsie, NY 12601",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Hudson",
      address: "560 Warren Street, Hudson, NY 12534",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Hudson DMV office for northern Red Hook and Columbia County residents. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 70 miles from Red Hook",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with domestic and international connections. Most convenient for Red Hook travelers heading to East Coast hubs.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: true,
    },
    {
      code: "SWF",
      name: "New York Stewart International Airport",
      distance: "About 55 miles from Red Hook",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley airport with direct flights to Dublin and connections to major U.S. hubs. Alternative for Red Hook travelers preferring southern routes.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "Stewart Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Online, mail, or in-person options for Dutchess County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS DOH Vital Records. Required for estate and legal matters in Dutchess County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Dutchess County Clerk at 22 Market Street in Poughkeepsie. Certified copies available for name changes.",
      url: "https://www.dutchessny.gov/Departments/County-Clerk/County-Clerk.htm",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Dutchess County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/9jd/dutchess/",
    },
  ],
};

export default redHookConfig;